import { ReportAttorneyComponent } from './pages/reports/attorney/attorney.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PrivateLayoutComponent } from './private-layout.component';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { SidebarComponent } from 'src/app/components/sidebar/sidebar.component';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { HomepageComponent } from 'src/app/layouts/private-layout/pages/homepage/homepage.component';
import { PatientsComponent } from './pages/patients/patients.component';
import { BreadcrumbComponent } from 'src/app/components/breadcrumb/breadcrumb.component';
import { AttorneyComponent } from './pages/attorney/attorney.component';
import { MriFacilityComponent } from './pages/mri-facility/mri-facility.component';
import { EmployeeComponent } from './pages/employee/employee.component';
import { ClinicComponent } from './pages/clinic/clinic.component';
import { MriComponent } from './pages/reports/mri/mri.component';
import { FlagComponent } from './pages/reports/flag/flag.component';
import { NonCompliantComponent } from './pages/reports/non-compliant/non-compliant.component';
import { InternalMedicineComponent } from './pages/appointments/internal-medicine/internal-medicine.component';
import { OrthopedistComponent } from './pages/appointments/orthopedist/orthopedist.component';
import { NeurologistComponent } from './pages/appointments/neurologist/neurologist.component';
import { RangeOfMotionComponent } from './pages/appointments/range-of-motion/range-of-motion.component';
import { RouteGuard } from 'src/app/auth/route.guard';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { TransportationChecklistComponent } from './pages/transportation-checklist/transportation-checklist.component';
import { PatientChecklistComponent } from './pages/patient-checklist/patient-checklist.component';
import { PainManagementComponent } from './pages/appointments/pain-management/pain-management.component';

const privateRoutes: Routes = [
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      {
        path: 'home',
        component: HomepageComponent
      },
      {
        path: 'patients',
        component: PatientsComponent
      },
      {
        path: 'attorney-list',
        component: AttorneyComponent
      },
      {
        path: 'report/mri',
        component: MriComponent
      },
      {
        path: 'report/attorney',
        component: ReportAttorneyComponent
      },
      {
        path: 'report/flag',
        component: FlagComponent
      },
      {
        path: 'report/non-compliant',
        component: NonCompliantComponent
      },
      {
        path: 'appointments/internal-medicine',
        component: InternalMedicineComponent
      },
      {
        path: 'appointments/orthopedist',
        component: OrthopedistComponent
      },
      {
        path: 'appointments/neurologist',
        component: NeurologistComponent
      },
      {
        path: 'appointments/range-of-motion',
        component: RangeOfMotionComponent
      },
      {
        path: 'mri-facility',
        component: MriFacilityComponent
      },
      {
        path: 'patient-checklist',
        component: PatientChecklistComponent
      },
      {
        path: 'transportation-checklist',
        component: TransportationChecklistComponent
      },
      {
        path: 'employee',
        component: EmployeeComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'clinic',
        component: ClinicComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'profile',
        component: UserProfileComponent
      },
      {
        path: 'appointments/pain-management',
        component: PainManagementComponent
      }
    ]
  }
];

@NgModule({
  declarations: [
    PrivateLayoutComponent,
    BreadcrumbComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    HomepageComponent,
    PatientsComponent,
    AttorneyComponent,
    MriFacilityComponent,
    EmployeeComponent,
    ClinicComponent,
    MriComponent,
    FlagComponent,
    NonCompliantComponent,
    InternalMedicineComponent,
    OrthopedistComponent,
    NeurologistComponent,
    RangeOfMotionComponent,
    UserProfileComponent,
    TransportationChecklistComponent,
    PatientChecklistComponent,
    ReportAttorneyComponent,
    PainManagementComponent
  ],
  imports: [CommonModule, RouterModule.forChild(privateRoutes), SharedModule]
})
export class PrivateLayoutModule {}
